/* eslint-disable */
export class BaseHook {
  static register(hooks) {
    this._getHooksSafe(hooks).push(this.execute);
  }

  static _getHooksSafe(hooks) {
    hooks[this.path] = hooks[this.path] || [];
    return hooks[this.path];
  }
}
